module.exports = __webpack_public_path__ + "img/icon-mulu.7819b4c8.svg";